import axios from "axios";
import toast from "react-hot-toast";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const apiRequest = async (
  method,
  url,
  data = null,
  isPrivate = false,
  isAdmin = false
) => {
  let headers = {};
  if (isPrivate) {
    let token = "";
    if (isAdmin) {
      token = localStorage.getItem("adminToken");
    } else {
      token = localStorage.getItem("userToken");
    }
    if (!token) {
      localStorage.clear();
      window.location.reload();
      return;
    }
    headers = {
      Authorization: `Bearer ${token}`,
    };
  }

  try {
    const response = await axios({
      method: method,
      url: `${apiUrl}${url}`,
      data: data,
      headers: headers,
    });
    return response.data;
  } catch (error) {
    console.error(`Error in ${method} request to ${url}:`, error.response || error);
    if (error.response?.status === 401) {
      localStorage.clear();
      toast.error("Session Expired. Please Login !!!");
      window.location.reload();
    } else if (error.response.status === 500) {
      toast.error(error?.response?.data || "Internal server error!!!");
    } else if (error.response.status === 400) {
      toast.error(error?.response?.data?.message || "Bad request!!!");
    }  else if (error.response.status === 404) {
      toast.error(error?.response?.data?.message || "Not found!!!");
    }else {
      toast.error("Something Went Wrong!!!");
    }
  }
};

export default apiRequest;
